<template>
  <footer
    class="flex flex-wrap lg:h-[2.25rem] items-center lg:justify-center text-sm p-1v lg:p-0 gap-1v lg:gap-1 text-grey-425 border-t-2 border-grey-625"
  >
    <PLink
      class="hover:text-grey-200"
      color="current"
      size="sm"
      :to="config.accessibilityDeclarationLink"
      :underline="false"
    >
      <span>Accessibilité : partiellement conforme</span>
    </PLink>
    <div class="h-2 mx-1v border-l border-grey-900" />
    <PLink class="hover:text-grey-200" color="current" size="sm" to="/site-map" :underline="false">
      <span>Plan du site</span>
    </PLink>
    <div class="h-2 mx-1v border-l border-grey-900" />
    <PLink class="hover:text-grey-200" color="current" size="sm" to="/versions" :underline="false">
      <span>Version {{ vNumber }}</span>
    </PLink>
    <div class="h-2 mx-1v border-l border-grey-900" />
    <PLink class="hover:text-grey-200" color="current" size="sm" :to="config.cguLink" :underline="false">
      <span>Mentions légales</span>
    </PLink>
    <div class="h-2 mx-1v border-l border-grey-900" />
    <PLink class="hover:text-grey-200" color="current" size="sm" to="/personnal-data" :underline="false">
      <span>Données personnelles</span>
    </PLink>
    <div class="h-2 mx-1v border-l border-grey-900" />
    <PLink
      class="hover:text-grey-200"
      color="current"
      size="sm"
      to="https://jedonnemonavis.numerique.gouv.fr/Demarches/3669?&view-mode=formulaire-avis&nd_source=button&key=ab6f3e67e351370b309b454860b7916a"
      :underline="false"
    >
      <span>Donner mon avis</span>
    </PLink>
  </footer>
</template>

<script setup lang="ts">
import { useConfig, PLink } from "@pasta/box-v2";
import { type ParapheurConfig } from "../types";
import { useVersionAnnouncementStore } from "../../version-announcement/version-announcement.store";
import { computed } from "vue";

const versionsStore = useVersionAnnouncementStore();
const vNumber = computed(() => {
  return (versionsStore.highestVersion?.number || "1").replace(/^v/, "");
});

const config = useConfig<ParapheurConfig>();
</script>
